var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{staticClass:"app-logo",attrs:{"name":"logo-header","width":null,"height":null}})}
var staticRenderFns = []

export { render, staticRenderFns }